import React, { useEffect, useState } from 'react';
import { Alert, Spinner, Table } from 'react-bootstrap';
import accountApi from '../../services/accountApi';

function PlatformPoliciesPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const payload = await accountApi.listPlatformPolicies();
        if (!cancelled) setData(payload);
      } catch (err) {
        if (!cancelled) setError(err.message || 'Failed to load policies');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <h1 className="product-page-title">Compatibility Policies</h1>
      <p className="product-page-subtitle">Unity/HDRP compatibility policy registry.</p>

      {error && <Alert variant="danger">{error}</Alert>}
      {loading && (
        <div className="loading-state">
          <Spinner animation="border" size="sm" className="me-2" />
          Loading…
        </div>
      )}

      {data && (
        <>
          <div className="product-card">
            <p className="mb-0">
              Active: <strong>{data.active_policy_id}</strong> v{data.active_policy_version}
            </p>
          </div>
          <div className="product-card">
            <Table responsive className="product-table" size="sm">
              <thead>
                <tr>
                  <th>Policy ID</th>
                  <th>Version</th>
                  <th>Unity versions</th>
                </tr>
              </thead>
              <tbody>
                {(data.policies || []).map((p) => (
                  <tr key={`${p.policy_id}-${p.policy_version}`}>
                    <td className="mono">{p.policy_id}</td>
                    <td>{p.policy_version}</td>
                    <td>{(p.supported_unity_versions || []).join(', ')}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </>
      )}
    </div>
  );
}

export default PlatformPoliciesPage;
